import { render, staticRenderFns } from "./relations-tab.vue?vue&type=template&id=1e626fdd&scoped=true"
import script from "./relations-tab.vue?vue&type=script&lang=js"
export * from "./relations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e626fdd",
  null
  
)

export default component.exports